import React from 'react'
import About from './About';
import Hero from '../Hero';
import SignUp from './SignUp';
import homeImage from "../../assets/images/hero/home.png"
import "../../css/Home/Header.css"


function Home() {
    return (
        <div>
            <Hero title="Bridging the gap between university and the workplace" heroImage={homeImage}/>
            <About/>
            <SignUp/>
        </div>
    )
}

export default Home;